import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";

const digitalSignal = {
  state: {
    listDigital: [],
    total: 0,
    count: 0,
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    async create(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/digitalSignal/create";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async update(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/digitalSignal/update";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    getList(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/digitalSignal/getList`;

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(_pick(payload, ["limit", "page", "search"])),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listDigital: res.data.list,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    async deleteDigital(payload, rootState) {
      let token = rootState.user.token;
      let url = DomainAPI + Channel + "/api/secure/digitalSignal/deleteDigital";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          idArray: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          // if (result.code === 1) this.getListCustomer()
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};
export default digitalSignal;
